<template>
  <sme-box :title="$t('dashboard.employees.pendingTitle')">
    <dashboard-stats :stats="stats" />
    <sme-alert v-if="showPendingEmployeesAlert" level="danger">
      <i18n-t path="dashboard.employees.pendingAlert" tag="span">
        <template #section>{{
          $t(portalUpdatesJan2026Enabled ? 'dashboard.shell.pill.actions' : 'dashboard.shell.pill.tasks')
        }}</template>
      </i18n-t>
    </sme-alert>
    <sme-alert v-else level="info">
      {{ $t('dashboard.employees.autoEnrolInfo') }}
      <SmeButtonLink @click="goToFilteredEmployees"> {{ $t('dashboard.employees.viewEnrollingLink') }} </SmeButtonLink>
    </sme-alert>
  </sme-box>
</template>

<script setup>
import { computed, onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import ApiClient from '@/ApiClient';
import SmeAlert from '@/components/atoms/SmeAlert';
import SmeBox from '@/components/atoms/SmeBox';
import SmeButtonLink from '@/components/atoms/SmeButtonLink';
import useFeatureFlags from '@/composables/useFeatureFlags';
import i18n from '@/i18n';
import DashboardStats from '@/pages/dashboard/components/DashboardStats';

const $router = useRouter();
const { canEnrollEmployees, portalUpdatesJan2026Enabled } = useFeatureFlags();

const props = defineProps({
  pendingEmployeesCount: {
    type: Number,
    required: true,
  },
});

const averagePendingTime = ref(0);

const showPendingEmployeesAlert = computed(() => {
  return props.pendingEmployeesCount > 0 && canEnrollEmployees.value;
});
const stats = computed(() => {
  return [
    {
      value: props.pendingEmployeesCount,
      explanation: i18n.t('dashboard.employees.pendingStat'),
    },
    {
      value: averagePendingTime.value,
      explanation: i18n.t('dashboard.employees.daysInPendingStat'),
    },
  ];
});

const goToFilteredEmployees = () => {
  $router.push({
    name: 'employees',
    query: {
      employee_status: 'ENROLLING',
    },
  });
};

onBeforeMount(async () => {
  const [averagePendingTimeData] = await Promise.all([ApiClient.smeGetAveragePendingTime()]);
  averagePendingTime.value = Math.round(averagePendingTimeData.data / 24);
});
</script>
